exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#small-calendar .v-btn--fab.v-size--default{height:33px;width:33px}#small-calendar .v-event-timed:hover{white-space:normal;height:100%!important}", ""]);

// exports
